interface ErrorState {
	message: string;
	show: boolean;
}

export interface State {
	value: string;
	error: ErrorState;
	valid: boolean | null;
}

export type Action =
	| { type: 'SET_PASSWORD_VALUE'; payload: string }
	| { type: 'SET_PASSWORD_ERROR'; payload: string }
	| { type: 'REMOVE_PASSWORD_ERROR' }
	| { type: 'SHOW_PASSWORD_ERROR' }
	| { type: 'HIDE_PASSWORD_ERROR' }
	| { type: 'RESET_PASSWORD_VALIDITY' }
	| { type: 'SET_PASSWORD_VALIDITY'; payload: boolean | null };


const Reducer = (state: State, action: Action): State => {
	switch (action.type) {
		case 'SET_PASSWORD_VALUE':
			return {
				...state,
				value: action.payload,
			};
		case 'SET_PASSWORD_ERROR':
			return {
				...state,
				error: { ...state.error, message: action.payload },
			};
		case 'REMOVE_PASSWORD_ERROR':
			return {
				...state,
				error: { ...state.error, message: '' },
			};
		case 'SHOW_PASSWORD_ERROR':
			return {
				...state,
				error: { ...state.error, show: true },
			};
		case 'HIDE_PASSWORD_ERROR':
			return {
				...state,
				error: { ...state.error, show: false },
			};
		case 'RESET_PASSWORD_VALIDITY':
			return {
				...state,
				valid: null,
			};
		case 'SET_PASSWORD_VALIDITY':
			return {
				...state,
				valid: action.payload,
			};
		default:
			return state;
	}
};

export default Reducer;
